import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import UploadDialog from "@/components/UploadDialog";
import PhotoCard from "@/components/PhotoCard";
import SelectionBar from "@/components/SelectionBar";
import { api } from "@/lib/api";
import { Heart, CheckSquare, X } from "lucide-react";

export default function Favorites() {
  const [uploadOpen, setUploadOpen] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [pets, setPets] = useState([]);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selected, setSelected] = useState([]);

  const load = async () => {
    const [ph, pt] = await Promise.all([
      api.get("/photos", { params: { favorite: true } }),
      api.get("/pets"),
    ]);
    setPhotos(ph.data);
    setPets(pt.data);
  };

  useEffect(() => { load(); }, []);

  const toggleSelect = (id) => setSelected((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const clear = () => { setSelected([]); setSelectionMode(false); };

  return (
    <div className="min-h-screen">
      <Nav onUpload={() => setUploadOpen(true)} />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-10 relative z-10 pb-32">
        <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="font-hand text-2xl text-[#E76F51] mb-1">the very best ones</div>
            <h1 className="font-display text-5xl font-bold text-[#2D232E] tracking-tight">Favorites</h1>
          </div>
          {photos.length > 0 && (
            <button
              data-testid="favorites-select-mode"
              onClick={() => { if (selectionMode) clear(); else setSelectionMode(true); }}
              className={`rounded-full font-semibold px-4 py-2 inline-flex items-center gap-1.5 text-sm transition-colors ${
                selectionMode ? "bg-[#2D232E] text-white" : "bg-white border border-[#EAE2D6] text-[#2D232E] hover:border-[#E76F51]"
              }`}
            >
              {selectionMode ? <><X className="w-4 h-4" /> Cancel</> : <><CheckSquare className="w-4 h-4" /> Select</>}
            </button>
          )}
        </div>

        {photos.length === 0 ? (
          <div className="rounded-3xl bg-white border border-[#EAE2D6] p-14 text-center warm-shadow">
            <div className="w-16 h-16 rounded-full bg-[#F4EFE6] flex items-center justify-center mx-auto mb-4">
              <Heart className="w-7 h-7 text-[#E76F51]" />
            </div>
            <h3 className="font-display text-2xl font-bold text-[#2D232E]">No favorites yet</h3>
            <p className="text-[#6A606C] mt-1">Tap the heart on any photo to save it here.</p>
          </div>
        ) : (
          <div className="columns-2 md:columns-3 lg:columns-4 gap-6">
            {photos.map((p, i) => (
              <PhotoCard
                key={p.id}
                photo={p}
                index={i}
                pets={pets}
                onUpdate={load}
                onDelete={load}
                selectionMode={selectionMode}
                selected={selected.includes(p.id)}
                onToggleSelect={toggleSelect}
                onCoverChanged={load}
              />
            ))}
          </div>
        )}
      </main>
      <SelectionBar selectedIds={selected} onClear={clear} onChanged={load} />
      <UploadDialog open={uploadOpen} onOpenChange={setUploadOpen} onUploaded={load} />
    </div>
  );
}
